import { ImpulseElement, property, registerElement, target } from '@ambiki/impulse';

@registerElement('onboarding-bubble')
export default class OnboardingBubbleElement extends ImpulseElement {
  @property({ type: Boolean }) open = false;
  @target() button: HTMLButtonElement;

  connected() {
    this.button.setAttribute('aria-expanded', this.open.toString());
  }

  /**
   * Called when the `open` attribute changes.
   */
  openChanged(newValue: boolean) {
    this.button.setAttribute('aria-expanded', newValue.toString());
  }

  toggle() {
    this.open = !this.open;
  }
}
